import React, {useCallback, useEffect, useState} from "react";
import {ArrowRightIcon} from '@heroicons/react/24/solid/index.js';
import {router, useForm} from '@inertiajs/react';
import toast from 'react-hot-toast';
import {Modal} from 'react-responsive-modal';

const InstallPWA = ({loginLink, recaptchaKey}) => {
    const [supportsPWA, setSupportsPWA] = useState(false);
    const [promptInstall, setPromptInstall] = useState(null);
    const [open, setIsOpen] = useState(false);
    const {data, setData, post, processing, errors, setError} = useForm({
        username: '',
        token: '',
    })
    const handleLoaded = _ => {
        window.grecaptcha.ready(_ => {
            console.log('ready');
            window.grecaptcha
                .execute(recaptchaKey, {action: "participate"})
                .then(newtoken => {
                    console.log('token ok');
                    console.log('setting recaptcha token');
                    setData('token', newtoken)
                })
        })
    }

    useEffect(() => {
        // Add reCaptcha
        const script = document.createElement("script")
        script.src = "https://www.google.com/recaptcha/api.js?render=" + recaptchaKey
        script.addEventListener("load", handleLoaded)
        document.body.appendChild(script)
    }, []);

    useEffect(() => {
        const handler = e => {
            e.preventDefault();
            console.log("we are being triggered :D");
            setSupportsPWA(true);
            setPromptInstall(e);
        };
        window.addEventListener("beforeinstallprompt", handler);

        return () => window.removeEventListener("transitionend", handler);
    }, []);

    useEffect(() => {
        console.log(errors, 'errors changed');
        if (errors.username) {
            toast.error(errors.username);
        }

        if (errors.refresh) {
            router.reload();
        }

        if (errors.error) {
            toast.error(errors.error);
        }
    }, [errors]);

    const submit = useCallback((e) => {
        e.preventDefault()

        if (!!data.username && data.username.length < 3) {
            setError('username', 'Please enter a name of at least three characters.')
            return;
        }

        post(loginLink)
    }, [data.username]);


    return (
        <>
            <Modal open={open} onClose={() => setIsOpen(false)} center>
                <div>
                    <h2 className="font-bold text-xl">Join event</h2>
                    <p className="text-sm">Please enter your full name to join this event.</p>

                    <form onSubmit={submit}>
                        <div className="flex flex-col mt-2">
                            <label className="font-bold" htmlFor="code">Full name</label>
                            <input
                                value={data.email}
                                onChange={e => setData('username', e.target.value)}
                                className="rounded-[10px]"
                                type="text"
                                autoComplete="name"
                                required
                                placeholder="Name" />
                            {!!errors.username && <span className="text-xs text-red-500">{errors.username}</span>}
                            <button
                                type="submit"
                                disabled={processing}
                                className="flex-wrap flex items-center justify-center shadow transition duration-300 transform px-6 py-3 font-medium text-white mt-[10px] rounded-[10px] focus:outline-none hover:shadow-md bg-primary-500 hover:bg-primary-500">
                                Join event <ArrowRightIcon className="w-4 h-4 text-white ml-2" />
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>

            <button
                disabled={!data.token}
                className="flex-wrap flex items-center justify-center shadow transition duration-300 transform px-6 py-3 font-medium text-white mt-[10px] rounded-[10px] focus:outline-none hover:shadow-md bg-primary-500 hover:bg-primary-500"
                onClick={() => setIsOpen(true)}
            >
                Continue <ArrowRightIcon className="w-4 h-4 text-white ml-2" />
            </button>
        </>


    )
};

export default InstallPWA;
